<!-- <app-user-section-access [sectionName]="guardSection()">
  <ng-template> -->
<app-comparable-companies-container></app-comparable-companies-container>
<!-- </ng-template>
</app-user-section-access> -->
